<template>
  <span class="d-flex">
    <span v-if="icon"  class="d-flex">
      <v-list-tile-action class="notranslate">
        <v-icon>translate</v-icon>
      </v-list-tile-action>

      <v-list-tile-content >
        <button style="" @click="dialog=true">Translate</button>
      </v-list-tile-content>
    </span>
    <span  class="d-flex" v-else>
      <button style="" @click="dialog=true">Translate</button>
    </span>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Select Language</v-card-title>

        <div class="pl-3">
          <Translator :countries="countries" @on-country-click="countrySelected" @onCountryClick="countrySelected1"/>
        </div>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import {Translator} from 'vue-google-translate'

export default {
  name: 'Translate',
  components: {
    Translator
  },
  props: {
    icon: {
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      countries: [
        {
          code: 'en|ar',
          title: 'Arabic'
        },
        {
          code: 'en|zh-CN',
          title: 'Chinese (Simplified)'
        },
        {
          code: 'en|en',
          title: 'English'
        },
        {
          code: 'en|tl',
          title: 'Filipino'
        },
        {
          code: 'en|fr',
          title: 'French'
        },
        {
          code: 'en|de',
          title: 'German'
        },
        {
          code: 'en|it',
          title: 'Italian'
        },
        {
          code: 'en|ko',
          title: 'Korean'
        },
        {
          code: 'en|pt',
          title: 'Portuguese'
        },
        {
          code: 'en|ru',
          title: 'Russian'
        },
        {
          code: 'en|es',
          title: 'Spanish'
        },
        {
          code: 'en|vi',
          title: 'Vietnamese',
          flagIconUrl: 'https://cdn.countryflags.com/thumbs/vietnam/flag-round-500.png'
        }
      ]
    }
  },
  methods: {
    countrySelected () {
      // eslint-disable-next-line no-console
      console.log('Country selected')
      this.dialog = false
    },
    countrySelected1 () {
      // eslint-disable-next-line no-console
      console.log('Country countrySelected1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Translate.vue